import { AttendanceStatus, CalendarEventModel, CalendarEventResponse, ODataResponse, UpdateCalendarEvent } from "../../data/entities";
import { AddCalendarEvent } from "../../data/entities";
import { CalendarEventODataRepo, CalendarEventRepo } from "../../data/repo";
export class CalendarEventService {
  private readonly calendarEventRepo = new CalendarEventRepo();
  private readonly calendarEventODataRepo = new CalendarEventODataRepo();

  async query(oDataQuery: string): Promise<ODataResponse<CalendarEventModel>> {
    return await this.calendarEventODataRepo.query(oDataQuery);
  }

  async getByUserLocationAsync(userId?: number | string, locationId?: number | string, startDate?: string, endDate?: string): Promise<CalendarEventModel[]> {
    return await this.calendarEventRepo.getByUserLocationAsync(userId, locationId, startDate, endDate)
  }

  async getByLocationProviderAsync(locationId: number | string, providerId: number | string, startDate?: string, endDate?: string): Promise<CalendarEventModel[]>{
    return this.calendarEventRepo.getByLocationProviderAsync(locationId, providerId, startDate, endDate)
  }

  async exportCalendarAsync(userId: number): Promise<string>{
    return await this.calendarEventRepo.exportCalendarAsync(userId)
  }

  async getByLocationCodeProviderAsync(locationCode: string, providerId: number | string): Promise<CalendarEventModel[]> {
    return await this.calendarEventRepo.getByLocationCodeProviderAsync(locationCode, providerId);
  }

  async getLatestCustomerNotesAsync(customerId: number): Promise<CalendarEventModel | null> {
    return await this.calendarEventRepo.getLatestCustomerNotesAsync(customerId);
  }

  async updateCalendarEventAsync(calendarEvent: UpdateCalendarEvent): Promise<CalendarEventResponse> {
    return await this.calendarEventRepo.updateCalendarEventAsync(calendarEvent);
  }

  async addCalendarEventAsync(eventInformation: AddCalendarEvent) : Promise<CalendarEventResponse> {
    return await this.calendarEventRepo.addCalendarEventAsync(eventInformation);
  }

  async deleteCalendarEventAsync(bookingEventId: number) : Promise<boolean> {
    return await this.calendarEventRepo.deleteCalendarEventAsync(bookingEventId);
  }

  async updateAttendanceStatusAsync(bookingEventId: number, attendanceStatus: AttendanceStatus): Promise<boolean> {
    return await this.calendarEventRepo.updateAttendanceStatusAsync(bookingEventId, attendanceStatus);
  }
}

export default CalendarEventService;
